const MINUTE = 60
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

export function formatCompactRelativeTime(isoTimestamp: string, now: number = Date.now()): string {
  const elapsed = Math.max(0, Math.floor((now - new Date(isoTimestamp).getTime()) / 1_000))
  if (elapsed < MINUTE) return `${elapsed} sec ago`
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min ago`
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)} hr ago`
  const days = Math.floor(elapsed / DAY)
  return `${days} ${days === 1 ? 'day' : 'days'} ago`
}
